import { useCurrentFilterStateById } from '../../../stores/FilterStateStore';
import { filterId } from './StatusFilter';

export const useStatusFilter = () => {
    const [statusFilterArr] = useCurrentFilterStateById(filterId);
    if (!statusFilterArr?.length) {
        return {
            green: true,
            yellow: true,
            orange: true,
            red: true,
            gray: true,
        };
    }
    return {
        green: statusFilterArr.includes('green'),
        yellow: statusFilterArr.includes('yellow'),
        orange: statusFilterArr.includes('orange'),
        red: statusFilterArr.includes('red'),
        gray: statusFilterArr.includes('gray'),
    };
};
